import { FieldKey } from '../../context/field-keys.js';
import { rentConversionRules } from '../../shared/conversion.js';
/**
 * Property asking-rate yearly <-> monthly conversions, ported from
 * `business-rules/property/rate-calc.ts` (avg/min/max direct & sublease, all via `commonRentCalc`).
 * Same `×12` / `÷12` math as lease. The `minMax*` functions there are validations and stay host-side.
 */
export const PROP_AVG_DIRECT_PAIR = {
  idPrefix: 'property.avg-direct-asking-rate',
  monthly: FieldKey.PropAvgDirectAskingRateMonthly,
  yearly: FieldKey.PropAvgDirectAskingRateYearly
};
export const PROP_AVG_SUBLEASE_PAIR = {
  idPrefix: 'property.avg-sublease-asking-rate',
  monthly: FieldKey.PropAvgSubleaseAskingRateMonthly,
  yearly: FieldKey.PropAvgSubleaseAskingRateYearly
};
export const PROP_MIN_DIRECT_PAIR = {
  idPrefix: 'property.min-direct-asking-rate',
  monthly: FieldKey.PropMinDirectAskingRateMonthly,
  yearly: FieldKey.PropMinDirectAskingRateYearly
};
export const PROP_MAX_DIRECT_PAIR = {
  idPrefix: 'property.max-direct-asking-rate',
  monthly: FieldKey.PropMaxDirectAskingRateMonthly,
  yearly: FieldKey.PropMaxDirectAskingRateYearly
};
export const PROP_MIN_SUBLEASE_PAIR = {
  idPrefix: 'property.min-sublease-asking-rate',
  monthly: FieldKey.PropMinSubleaseAskingRateMonthly,
  yearly: FieldKey.PropMinSubleaseAskingRateYearly
};
export const PROP_MAX_SUBLEASE_PAIR = {
  idPrefix: 'property.max-sublease-asking-rate',
  monthly: FieldKey.PropMaxSubleaseAskingRateMonthly,
  yearly: FieldKey.PropMaxSubleaseAskingRateYearly
};
export const propertyRateRules = [...rentConversionRules(PROP_AVG_DIRECT_PAIR), ...rentConversionRules(PROP_AVG_SUBLEASE_PAIR), ...rentConversionRules(PROP_MIN_DIRECT_PAIR), ...rentConversionRules(PROP_MAX_DIRECT_PAIR), ...rentConversionRules(PROP_MIN_SUBLEASE_PAIR), ...rentConversionRules(PROP_MAX_SUBLEASE_PAIR)];
